
<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-card class="rounded-xl" max-width="400">
        <v-card-title class="headline d-flex justify-center">
          Подтвердите e-mail
        </v-card-title>

        <v-card-text>
          Чтобы продолжить пользоваться сайтом, необходимо подтвердить e-mail
          адрес
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>


<script>
export default {
  data: () => ({}),

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      var token = localStorage.getItem("token");
      if (token) {
        vm.$router.push({ name: "home" });
      }
    });
  },
};
</script>